import React, { FC } from 'react';
import styled from '@emotion/styled'
import AceEditor from 'react-ace';

import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/ext-language_tools';

interface EditorProps {
  name: string;
  mode: string;
  content: string;
  readOnly?: boolean;
  onChange?: (value: string, event?: any) => void;
}

const StyledEditor = styled(AceEditor)`
  border: 1px solid #E8E8E8;
`;

export const Editor: FC<EditorProps> = ({
  name, mode, content, readOnly, onChange
}) => {

  return <StyledEditor
    theme="github"
    mode={mode}
    name={name}
    value={content}
    fontSize={14}
    height={'100%'}
    width={'100%'}
    readOnly={readOnly}
    wrapEnabled={true}
    focus={true}
    editorProps={{ $blockScrolling: true }}
    onChange={onChange}
    setOptions={{
      useWorker: false,
      enableBasicAutocompletion: true,
      enableLiveAutocompletion: true,
      enableSnippets: false,
      showLineNumbers: true,
      tabSize: 2,
    }}
  />
};
